import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAlignVerticalTop';
/** Renders an SVG icon. */
const SvgAlignVerticalTop = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 26a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2zm6 0H9V10h4zm4-9a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2zm6 0h-4v-7h4zM4 5a1 1 0 0 0 1 1h22a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgAlignVerticalTop.displayName = displayName;
export default SvgAlignVerticalTop;
